<template>
  <div class="row g-1" v-if="flight.holes.length > 0">
    <div
      :class="`${flight.holes.length == 18 ? 'col-4' : 'col-12'} col-xl-2`"
      v-for="i in Math.ceil(flight.holes.length / 3)"
      :key="i"
    >
      <div class="row g-1">
        <div
          class="col-4"
          v-for="(hole, holeIndex) in flight.holes.slice((i - 1) * 3, i * 3)"
          :key="`${flight.id}:${holeIndex}`"
        >
          <hole-column
            @click="onClick($event, flight, flightIndex, hole)"
            :classes="'mobile'"
            :hole="hole"
            :isStartHole="hole.number == flight.startHole"
          ></hole-column>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import HoleColumn from "./hole_column.vue";

export default defineComponent({
  props: {
    flight: Object,
    flightIndex: Number,
    onClick: Function,
  },
  components: {
    HoleColumn,
  },
});
</script>
